import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

const loader = new GLTFLoader();
const cache = new Map<string, THREE.Object3D>();

export async function loadToothMesh(
  path: string
): Promise<THREE.Object3D> {
  // Return cached clone
  if (cache.has(path)) {
    return clone(cache.get(path)!);
  }

  const gltf = await loader.loadAsync(path);
  const scene = gltf.scene;

  // Normalize once (safe)
  scene.traverse((child) => {
    const mesh = child as THREE.Mesh;
    if (mesh.isMesh) {
      mesh.castShadow = true;
      mesh.receiveShadow = true;
    }
  });

  // ❌ REMOVE ALL ROTATION FROM HERE
  // scene.rotation.x = -Math.PI / 2; ❌

  cache.set(path, scene);

  return clone(scene);
}